export default __webpack_public_path__ + "static/media/bg-historia.9c50fca0.jpg";